import React, { useEffect, useRef } from "react";
import Countdown from "@/components/Countdown";

const HERO_IMG = "/images/manor.png";

const Hero = () => {
  const imgRef = useRef(null);

  useEffect(() => {
    const onScroll = () => {
      const el = imgRef.current;
      if (!el) return;
      const y = window.scrollY;
      el.style.transform = `translate3d(0, ${y * 0.18}px, 0) scale(${1 + y * 0.0004})`;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="hero" id="top" data-testid="hero">
      <div className="hero-media">
        <div className="hero-media-inner" ref={imgRef}>
          <img src={HERO_IMG} alt="Watercolour of a Cotswolds manor at dusk" />
          <div className="hero-overlay" />
        </div>
      </div>

      <div className="hero-copy">
        <p className="eyebrow">Together with their families</p>
        <h1 className="hero-title">
          <span>Rebecca</span>
          <span className="amp">&amp;</span>
          <span>Tom</span>
        </h1>
        <div className="date-line">Saturday · 21st November 2026</div>
        <p className="venue-line">Foxhill Manor · The Cotswolds</p>

        <Countdown />

        <div className="hero-cta-row">
          <a
            className="btn primary"
            href="#rsvp"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("rsvp")?.scrollIntoView({ behavior: "smooth" });
            }}
            data-testid="hero-rsvp-btn"
          >
            RSVP
          </a>
          <a
            className="btn ghost"
            href="#day"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("day")?.scrollIntoView({ behavior: "smooth" });
            }}
          >
            View details
          </a>
        </div>
      </div>
    </header>
  );
};

export default Hero;
